import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  eventTypeListReq,
  setSessionFilterBy,
  setSessionFilterByClear,
  setSessionFilterEventType,
  setSessionFilterEventTypeClear,
} from "../../redux/events/actions";
import { SessionKeys } from "../../utils/AppUtils";
import _ from "lodash";

const CustomToolbar = (toolbar) => {

  const [isCurrent, SetIsCurrent] = useState("week");
  const [filterBy, setFilterBy] = useState("all");
  const [filterEventType, setFilterEventType] = useState("all");


  const dispatch = useDispatch();
  const role = useSelector((state) => state.user.role);
  const iframeRole = useSelector((state) => state.user.iframeRole);
  const sessionFilterBy = useSelector((state) => state.events.sessionFilterBy);
  const isMobileDevice = useSelector((state) => state.user.isMobileWebView);
  const eventTypeListRes = useSelector((state) => state.events.eventTypeList);

  const sessionFilterEventType = useSelector((state) => state.events.sessionFilterEventType);

  const [userRole, setUserRole] = useState('')
  const [typeList, setTypeList] = useState([]);

  useEffect(() => {
    if (!_.isEmpty(sessionFilterEventType)) {
      setFilterEventType(sessionFilterEventType)
    }
  }, [sessionFilterEventType])

  useEffect(() => {
    console.log('getEventTypeListRes: ', eventTypeListRes)
    if (!_.isEmpty(eventTypeListRes)) {
      if (eventTypeListRes.status === "success") {
        let typeList = eventTypeListRes?.payload?.payload;
        setTypeList(typeList);
      }
    }
  }, [eventTypeListRes])

  useEffect(() => {
    console.log('isMOBILEDEVICE', isMobileDevice)
    if (isMobileDevice) {
      setUserRole(iframeRole)
    } else {
      setUserRole(role)
    }
  }, [role, iframeRole, isMobileDevice])

  useEffect(() => {
    console.log('filter by is changed', filterBy)
    // dispatch(setSessionFilterBy(filterBy));
    // toolbar.setSessionFilterBy(filterBy)
    return (() => {
      dispatch(setSessionFilterBy(''))
    })
  }, [filterBy]);

  // useEffect(() => {
  //   if (sessionFilterBy) {
  //     console.log(sessionFilterBy)
  //     setFilterBy(sessionFilterBy)
  //   }
  // }, [sessionFilterBy])

  useEffect(() => {
    // console.log(toolbar)
    if (toolbar.view) {
      SetIsCurrent(toolbar.view);
    }
  }, [toolbar]);

  const goToBack = () => {
    if (isCurrent === "month") {
      toolbar.date.setMonth(toolbar.date.getMonth() - 1);
    } else if (isCurrent === "day") {
      toolbar.date.setDate(toolbar.date.getDate() - 1);
    } else if (isCurrent === "week") {
      toolbar.date.setDate(toolbar.date.getDate() - 7);
    }
    toolbar.onNavigate("prev");
  };

  const goToNext = () => {
    if (isCurrent === "month") {
      toolbar.date.setMonth(toolbar.date.getMonth() + 1);
    } else if (isCurrent === "day") {
      toolbar.date.setDate(toolbar.date.getDate() + 1);
    } else if (isCurrent === "week") {
      toolbar.date.setDate(toolbar.date.getDate() + 7);
    }
    toolbar.onNavigate("next");
  };

  const goToCurrent = () => {
    const now = new Date();
    toolbar.date.setMonth(now.getMonth());
    toolbar.date.setYear(now.getFullYear());
    toolbar.onNavigate("current");
  };

  const monthView = () => {
    SetIsCurrent("month");
    toolbar.onView("month");
  };
  const dayView = () => {
    SetIsCurrent("day");
    toolbar.onView("day");
  };
  const weekView = () => {
    SetIsCurrent("week");
    toolbar.onView("week");
  };

  const label = () => {
    const date = moment(toolbar.date);
    if (isCurrent === "month" || isCurrent === "week") {
      return (
        <span>
          <b>{date.format("MMMM")}</b>,<span> {date.format("YYYY")}</span>
        </span>
      );
    } else if (isCurrent === "day") {
      return (
        <span>
          {date.format("DD")}&nbsp;<b>{date.format("MMMM")}</b>,
          <span> {date.format("YYYY")}</span>
        </span>
      );
    }
  };
 const togglenavs = () => {
    var btnEl = document.querySelector(".sidecal");
    var main = document.querySelector(".full-cal");
    var toogleicon = document.querySelector(".arrow-side-cal")
   
    // console.log(btnClasslist)
    if (btnEl.classList.contains("open")) {
      //document.getElementById("openbtnd").innerHTML = "<span class='closetoogle'></span>";
      btnEl.classList.remove("open");
      toogleicon.classList.add("closeopen");
      main.style.width = "100%";
      
    } else {
      //document.getElementById("openbtnd").innerHTML ="<span class='opentogglbar'></span>";
      btnEl.classList.add("open");
      toogleicon.classList.remove("closeopen");
      main.style.width = "75%";
     
    }
  };
  return (
    <div className="mb-2">
      <div className="d-flex justify-content-between align-items-start filter-box-sec">
        <div className="left-btn-cl-box">
          <div className="d-flex gap-1">
            <button
              className={`btn btn-primary btn-block setup-button upgrate_colpeteBtn mr-2 ${isCurrent === "day" ? "active" : ""
                }`}
              onClick={dayView}
            >
              Day
            </button>
            <button
              className={`btn btn-primary btn-block setup-button upgrate_colpeteBtn mr-2 ${isCurrent === "month" ? "active" : ""
                }`}
              onClick={monthView}
            >
              Month
            </button>
            <button
              className={`btn btn-primary btn-block setup-button upgrate_colpeteBtn mr-2 ${isCurrent === "week" ? "active" : ""
                }`}
              onClick={weekView}
            >
              Week
            </button>
          </div>
          <div className="arrow-side-cal cursor-pointer closeopen" onClick={togglenavs}>
          <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  id="Next"
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                >
                  <defs>
                    <linearGradient
                      id="linear-gradient"
                      y1="0.5"
                      x2="1"
                      y2="0.5"
                      gradientUnits="objectBoundingBox"
                    >
                      <stop offset="0" stopColor="#6941C6"></stop>
                      <stop offset="1" stopColor="#ed156e"></stop>
                    </linearGradient>
                  </defs>
                  <circle
                    id="Ellipse_57"
                    data-name="Ellipse 57"
                    cx="15"
                    cy="15"
                    r="15"
                    fill="url(#linear-gradient)"
                  ></circle>
                  <circle
                    id="Ellipse_179"
                    data-name="Ellipse 179"
                    cx="13"
                    cy="13"
                    r="13"
                    transform="translate(2 2)"
                    fill="#fff"
                  ></circle>
                  <g
                    id="Group_1344"
                    data-name="Group 1344"
                    transform="translate(39.406 -779.787) rotate(45)"
                  >
                    <path
                      id="Path_415"
                      data-name="Path 415"
                      d="M0,8H8V0"
                      transform="translate(536.5 587.5) rotate(-90)"
                      fill="none"
                      stroke="#6941C6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="4"
                    ></path>
                  </g>
                  <g
                    id="Group_1345"
                    data-name="Group 1345"
                    transform="translate(47.406 -779.787) rotate(45)"
                  >
                    <path
                      id="Path_416"
                      data-name="Path 416"
                      d="M0,8H8V0"
                      transform="translate(536.5 587.5) rotate(-90)"
                      fill="none"
                      stroke="#6941C6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="4"
                    ></path>
                  </g>
                </svg>
          </div>
        </div>
        <div className="filter-box-cal-new">
          <div className="d-flex button-filteralignment">
            <div className="button-cal-new">
              <button className="button-reset" onClick={goToBack}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  id="Back"
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                >
                  <defs>
                    <linearGradient
                      id="linear-gradient"
                      y1="0.5"
                      x2="1"
                      y2="0.5"
                      gradientUnits="objectBoundingBox"
                    >
                      <stop offset="0" stopColor="#6941C6" />
                      <stop offset="1" stopColor="#ed156e" />
                    </linearGradient>
                  </defs>
                  <circle
                    id="Ellipse_57"
                    data-name="Ellipse 57"
                    cx="15"
                    cy="15"
                    r="15"
                    fill="url(#linear-gradient)"
                  />
                  <circle
                    id="Ellipse_179"
                    data-name="Ellipse 179"
                    cx="13"
                    cy="13"
                    r="13"
                    transform="translate(2 2)"
                    fill="#fff"
                  />
                  <g
                    id="Group_1344"
                    data-name="Group 1344"
                    transform="translate(22 15.002) rotate(135)"
                  >
                    <path
                      id="Path_415"
                      data-name="Path 415"
                      d="M0,0H8V8"
                      transform="translate(8.001 0) rotate(90)"
                      fill="none"
                      stroke="#6941C6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="4"
                    />
                  </g>
                </svg>
              </button>
              <button className="button-reset pe-0" onClick={goToNext}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  id="Next"
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                >
                  <defs>
                    <linearGradient
                      id="linear-gradient"
                      y1="0.5"
                      x2="1"
                      y2="0.5"
                      gradientUnits="objectBoundingBox"
                    >
                      <stop offset="0" stopColor="#6941C6"></stop>
                      <stop offset="1" stopColor="#ed156e"></stop>
                    </linearGradient>
                  </defs>
                  <circle
                    id="Ellipse_57"
                    data-name="Ellipse 57"
                    cx="15"
                    cy="15"
                    r="15"
                    fill="url(#linear-gradient)"
                  ></circle>
                  <circle
                    id="Ellipse_179"
                    data-name="Ellipse 179"
                    cx="13"
                    cy="13"
                    r="13"
                    transform="translate(2 2)"
                    fill="#fff"
                  ></circle>
                  <g
                    id="Group_1344"
                    data-name="Group 1344"
                    transform="translate(43.406 -779.787) rotate(45)"
                  >
                    <path
                      id="Path_415"
                      data-name="Path 415"
                      d="M0,8H8V0"
                      transform="translate(536.5 587.5) rotate(-90)"
                      fill="none"
                      stroke="#6941C6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="4"
                    ></path>
                  </g>
                </svg>
              </button>
            </div>
            <label className="calendar-label-title">{label()}</label>
          </div>

        {false && <div className="input-text cal-flter-box">
          <label htmlFor="filter" className="input__label">
            Event Type
          </label>
          <select
            // type="text"
            id="filter"
            name="filter"
            className="form-select input_searchfield mb-0 session-filter"
            value={filterEventType}
            placeholder=""
            onChange={(e) => {
              e.preventDefault();
              console.log('TRIGGER', e.target.value)
              if (e.target.value) {
                setFilterEventType(e.target.value);
                dispatch(setSessionFilterEventType(e.target.value));
                // toolbar.setSessionFilterBy(e.target.value)
              } else {
                setFilterEventType(e.target.value);
                // dispatch(setSessionFilterBy(e.target.value));
                // toolbar.setSessionFilterBy(e.target.value)
                dispatch(setSessionFilterEventTypeClear());
              }
            }}
          >
            <>
              <option value="all">All</option>
              {typeList?.map((item, index) => { return <option value={item?.id}>{item?.name}</option> })}

            </>
          </select>
        </div>}
        <div className="input-text cal-flter-box">
          <label htmlFor="filter" className="input__label">
            Filter By
          </label>
          <select
            // type="text"
            id="filter"
            name="filter"
            className="form-select input_searchfield mb-0 session-filter"
            value={filterBy}
            placeholder=""
            onChange={(e) => {
              e.preventDefault();
              console.log('TRIGGER', e.target.value)
              if (e.target.value) {
                setFilterBy(e.target.value);
                dispatch(setSessionFilterBy(e.target.value));
                // toolbar.setSessionFilterBy(e.target.value)
              } else {
                setFilterBy(e.target.value);
                // dispatch(setSessionFilterBy(e.target.value));
                // toolbar.setSessionFilterBy(e.target.value)
                dispatch(setSessionFilterByClear());
              }
            }}
          >

            {
              (userRole === "realtor" || userRole === "customer" || userRole === "manager") ?
                <>
                  <option value="all">All</option>
                  <option value="buy">Available for Purchase</option>
                  <option value="free">Free</option>
                  <option value="enrolled">My Enrolled Sessions</option>
                  <option value="host">Hosted By Me</option>
                </>
                :
                (userRole === "broker" || userRole === "admin") ?
                  <option value="host">Hosted By Me</option>
                  :
                  <>
                    <option value="all">All</option>
                    <option value="host">Hosted By Me</option>
                  </>
            }
          </select>
        </div>
        </div>
      </div>
    </div>
  );
};

export default CustomToolbar;
